<template>
  <div class="device-manage">
    <div class="breadcrumb">设备绑定申请</div>
    <div class="search">
      <el-select v-model="keyType">
        <el-option label="用户ID" value="1"></el-option>
        <el-option label="姓名" value="2"></el-option>
        <el-option label="手机号" value="3"></el-option>
        <el-option label="学号" value="4"></el-option>
      </el-select>

      <div class="el-input">
        <el-input
          type="text"
          :placeholder="placeholder"
          v-model="keyword"
          @keyup.enter="search"
        ></el-input>
      </div>

      <el-select v-model="status">
        <el-option label="全部状态" value="0"></el-option>
        <el-option label="申请中" value="1"></el-option>
        <el-option label="已通过" value="2"></el-option>
        <el-option label="未通过" value="3"></el-option>
      </el-select>

      <el-button type="primary" @click="search">搜索</el-button>
    </div>

    <div class="com-list">
      <el-table :data="list" style="overflow-x: auto">
        <el-table-column prop="index" label="序号" width="70px">
        </el-table-column>
        <el-table-column prop="uid" label="用户ID" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="125px">
        </el-table-column>
        <el-table-column prop="name" label="姓名"> </el-table-column>
        <el-table-column
          prop="stuId"
          label="学号/教职工号"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="campuszones" label="校区" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="className" label="院系" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          inline-template
          label="申请设备信息"
          show-overflow-tooltip
        >
          <span
            style="line-height: 40px; display: inline-block"
            @click="showImg(row)"
            >{{ row.customDeviceId }}</span
          >
        </el-table-column>
        <el-table-column prop="num" label="用户已绑定次数"> </el-table-column>
        <el-table-column label="操作" inline-template>
          <div>
            <div v-if="row.isPassed == 0">
              <el-button
                class="optionbtn"
                type="text"
                @click="checkCompalinPass(row)"
                >通过</el-button
              >
              <el-button
                class="optionbtn"
                type="text"
                @click="checkCompalinNot(row)"
                >不通过</el-button
              >
            </div>
            <div v-if="row.isPassed !== 0">
              <span class="optionbtnss" v-if="row.isPassed == 1">已通过</span>
              <span class="optionbtnss" v-if="row.isPassed == 2">未通过</span>
            </div>
          </div>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          v-show="this.totalCount > 0"
          layout="prev, pager, next, jumper"
          :page-size="10"
          :current-page="currentPage"
          :total="totalCount"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 详情弹框 -->
    <el-dialog
      title="设备信息详情"
      v-model="dialogVisible"
      :modal-append-to-body="false"
    >
      <div class="dialogcont">
        <p>设备类型：{{ osType }}</p>
        <p>设备型号：{{ deviceModel }}</p>
        <p v-if="imei">imei：{{ imei }}</p>
        <p v-if="androidId">androidId：{{ androidId }}</p>
        <p v-if="idfa">idfa：{{ idfa }}</p>
        <p v-if="deviceId">deviceId：{{ deviceId }}</p>
        <p>逻辑分辨率：{{ logicPixel }}</p>
        <p>物理分辨率：{{ physicPixel }}</p>
        <p v-if="blMac">蓝牙MC：{{ blMac }}</p>
        <p v-if="wifiMac">WiFiMC：{{ wifiMac }}</p>
        <p>CPU型号：{{ cpuModel }}</p>
        <p>是否root：{{ isRoot }}</p>
        <p v-if="appUpdateTime">App更新时间：{{ appUpdateTime }}</p>
        <p>App安装时间：{{ appInstallTime }}</p>
        <p>设备指纹：{{ fingerprint }}</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      totalCount: 0,
      status: "0",
      keyType: "1",
      keyword: "",
      currentPage: this.$util.getUrlParam("pageNum") * 1 || 1,
      dialogVisible: false,
      osType: "", // 0 安卓，1 ？IOS
      imei: "", // 只有安卓有
      androidId: "", // Android
      idfa: "", // IOS
      deviceId: "", // IOS
      logicPixel: "", //逻辑分辨率
      physicPixel: "", //物理分辨率
      blMac: "", //蓝牙MC
      wifiMac: "", //
      cpuModel: "", //CPU型号
      isRoot: 0, // 0 没有Root  ， 1 有Root
      appUpdateTime: "", // APP更新时间
      appInstallTime: "", //APP安装时间
      fingerprint: "", // 设备指纹
      isUsed: "", //是否被使用
    };
  },
  mounted() {
    this.getComplainList();
  },
  computed: {
    placeholder() {
      if (this.keyType === "1") {
        return "请输入用户ID";
      } else if (this.keyType === "2") {
        return "请输入姓名";
      } else if (this.keyType === "3") {
        return "请输入手机号";
      } else {
        return "请输入学号";
      }
    },
  },
  methods: {
    search() {
      this.getComplainList();
    },

    // 弹框详情
    showImg(row) {
      this.dialogVisible = true;
      this.osType = row.osType == 1 ? "IOS" : "Android"; // 0 安卓，1 ？IOS
      this.imei = row.imei; // 只有安卓有
      this.androidId = row.androidId; // Android
      this.idfa = row.idfa; // IOS
      this.deviceId = row.deviceId; // IOS
      this.logicPixel = row.logicPixel; //逻辑分辨率
      this.physicPixel = row.physicPixel; //物理分辨率
      this.blMac = row.blMac; //蓝牙MC
      this.wifiMac = row.wifiMac; //
      this.cpuModel = row.cpuModel; //CPU型号
      this.isRoot = row.isRoot == 1 ? "有root" : "没有root"; // 0 没有Root  ， 1 有Root
      this.appUpdateTime =
        row.appUpdateTime > 0
          ? new Date(row.appUpdateTime).format("yyyy/MM/dd")
          : ""; // APP更新时间
      this.appInstallTime =
        row.appInstallTime > 0
          ? new Date(row.appInstallTime).format("yyyy/MM/dd")
          : ""; //APP安装时间
      this.fingerprint = row.fingerprint; // 设备指纹
      this.deviceModel = row.deviceModel; //设备型号
    },

    checkCompalinPass(row) {
      let id = row.id;
      this.checkCompalin(1, id);
    },

    checkCompalinNot(row) {
      let id = row.id;
      this.checkCompalin(2, id);
    },

    // 申诉处理
    checkCompalin(type, id) {
      // 对申诉进行处理
      let url = this.$util.domain + "/adminapi/v3/user/device/check";

      this.$http({
        url,
        method: "POST",
        body: JSON.stringify({
          id,
          isPass: type * 1,
        }),
      }).then(
        (response) => {
          if (response.data.error == 10000) {
            this.getComplainList();
          } else {
            this.$util.errorMsg(response.data.message);
          }
        },
        (response) => {
          this.$util.errorMsg(response.data.message);
        }
      );
    },

    //获取申诉信息列表
    getComplainList() {
      let url = this.$util.domain + "/adminapi/v3/user/device/list";
      //0,忽略关键字;
      let keyType = this.keyword ? this.keyType * 1 : 0;

      this.$http({
        url,
        method: "POST",
        body: JSON.stringify({
          keyType,
          status: this.status * 1,
          keyword: this.keyword,
          pageSize: 10,
          pageNum: this.currentPage,
        }),
      }).then(
        (response) => {
          this.list = [];
          if (response.data.error == 10000) {
            let dataList = response.data.data.rows;
            this.totalCount = response.data.data.total;
            if (dataList && dataList.length > 0) {
              dataList.forEach((item, index) => {
                this.list.push({ ...item, index: index + 1 });
              });
            }
          } else {
            this.$util.errorMsg(response.data.message);
          }
        },
        (response) => {
          this.$util.errorMsg(response.data.message);
        }
      );
    },
    //请求分页数据
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getComplainList();
    },
  },
};
</script>
<style scoped>
.device-manage .el-select {
  display: inline-block;
}

.device-manage .el-input {
  display: inline-block;
  width: auto;
}

.device-manage .el-button {
  display: inline-block;
}

.device-manage .el-button + .el-button {
  margin-left: 0;
}

.device-manage .search {
  margin-left: 30px;
  margin-bottom: 20px;
}

.device-manage .optionbtn {
  margin-right: 15px;
}

.device-manage .el-table .cell {
  text-overflow: clip;
}

.device-manage .dialogcont {
  /* text-align: center; */

  min-height: 400px;
}

.device-manage .dialogcont p {
  margin-left: 30px;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// deviceComplain.vue?181619bc